import React, {useState} from "react";
import {Button} from "react-bootstrap";
import InvitePeople from "../User/InvitePeople";
import InvitedMember from "../User/InvitedMember";
import InvitedMemberEdit from "../User/InvitedMemberEdit";

function ListOrgInvitedUsers(props: {
  org: any,
  invitedUsers: any,
  permissionAdmin: boolean,
  loadData: any
}) {
  const {org, invitedUsers, permissionAdmin, loadData} = props;
  const [showMemberEdit, setShowMemberEdit] = useState(false);
  const [user, setUser] = useState();
  const [showInvite, setShowInvite] = useState(false);

  const showEdit = permissionAdmin ? function (userId: string) {
    const user = invitedUsers.find(function (user: any) {
      return user.id === userId;
    });
    console.log({user})

    setUser(user);
    setShowMemberEdit(true);
  } : null;

  const invitedUsersList = invitedUsers.map((user: any) =>
    <InvitedMember user={user} key={user.id} showEdit={showEdit}/>) || [];

  const subMessage = permissionAdmin && !org.id ?
    <li>
      (Save first then add people)
    </li>
    : null;

  const inviteButton = permissionAdmin && org.id ?
    <li className="py-2">
      <Button
        onClick={() => setShowInvite(true)}
        variant="secondary">
        Invite
      </Button>
    </li>
    : null;

  return (
    <>
      <ul className="pt-1">
        <li className="text-nowrap">
          <b>Admins can invite existing Villa members to their org or<br/>to a particular Villa, respectively. Be sure to use the email<br/>they signed up to Villa with.</b>
        </li>
        {inviteButton}
        {subMessage}
        {invitedUsersList}
      </ul>
      <InvitedMemberEdit
        invitedUser={user}
        loadData={loadData}
        show={showMemberEdit}
        onHide={() => {
          setShowMemberEdit(false);
          loadData();
        }}
      />
      <InvitePeople
        org={org}
        permissionAdmin={permissionAdmin}
        loadData={loadData}
        onHide={() => setShowInvite(false)}
        show={showInvite}
      />
    </>
  )
}

export default ListOrgInvitedUsers;
